// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_s3-5";
export var filledCircle = "_s3-4";
export var historyEntry = "_s3-3";
export var messageSideLeft = "_s3-1";
export var messageSideRight = "_s3-2";
export var orderTrackingCarouselWrapper = "_s3-6";
export var orderTrackingInfoContainer = "_s3-0";